import { Brick, registerBrick, Cache, BrickContext } from 'olympe';
import { firstValueFrom } from 'rxjs';

export default class IsAssessmentSavedOnCache extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(boolean)} setResult
     */
    async update($, input, [forwardEvent, setResult]) {
        const cachedValue = await firstValueFrom(Cache.getCacheEntries());
        setResult(cachedValue.some((assessment) => assessment.startsWith('Assessment_')));
        forwardEvent();
    }
}

registerBrick('018c7d0c8a422b016e5b', IsAssessmentSavedOnCache);
